<script>
import TemplatesPicker from './TemplatesPicker.vue';
import WhatsAppTemplateReply from './WhatsAppTemplateReply.vue';
export default {
  components: {
    TemplatesPicker,
    WhatsAppTemplateReply,
  },
  props: {
    show: {
      type: Boolean,
      default: false,
    },
    inboxId: {
      type: Number,
      default: undefined,
    },
  },
  emits: ['onSend', 'cancel', 'update:show'],
  data() {
    return {
      selectedWaTemplate: null,
    };
  },
  computed: {
    localShow: {
      get() {
        return this.show;
      },
      set(value) {
        this.$emit('update:show', value);
      },
    },
    modalHeaderContent() {
      return 'Escolha um template, confira o resumo e envie quando estiver tudo certo.';
    },
  },
  methods: {
    pickTemplate(template) {
      this.selectedWaTemplate = template;
    },
    onResetTemplate() {
      this.selectedWaTemplate = null;
    },
    onSendMessage(message) {
      this.$emit('onSend', message);
    },
    onClose() {
      this.$emit('cancel');
    },
  },
};
</script>

<template>
  <woot-modal
    v-model:show="localShow"
    :on-close="onClose"
    size="whatsapp-template-modal"
  >
    <woot-modal-header
      :header-title="$t('WHATSAPP_TEMPLATES.MODAL.TITLE')"
      :header-content="modalHeaderContent"
    />
    <div class="modal-content">
      <div class="h-full min-h-0">
        <section class="h-full min-h-0 overflow-hidden rounded-lg border border-solid border-n-weak bg-n-alpha-2 p-4">
          <WhatsAppTemplateReply
            v-if="selectedWaTemplate"
            :template="selectedWaTemplate"
            @reset-template="onResetTemplate"
            @send-message="onSendMessage"
          >
            <template #before-form>
              <div class="mb-4 space-y-3">
                <TemplatesPicker
                  :inbox-id="inboxId"
                  :selected-template-id="selectedWaTemplate?.id"
                  @on-select="pickTemplate"
                />
                <div class="rounded-md bg-n-alpha-2 px-3 py-2">
                  <p class="text-xs font-medium uppercase text-[#128c4a]">
                    Template selecionado
                  </p>
                  <h3 class="mt-1 truncate text-sm font-semibold text-n-slate-12">
                    {{ selectedWaTemplate.name }}
                  </h3>
                </div>
              </div>
            </template>
          </WhatsAppTemplateReply>
          <div
            v-else
            class="grid h-full min-h-0 gap-5 lg:grid-cols-[minmax(0,1fr)_27rem]"
          >
            <div class="min-h-0 overflow-y-auto pr-1">
              <TemplatesPicker
                :inbox-id="inboxId"
                :selected-template-id="selectedWaTemplate?.id"
                @on-select="pickTemplate"
              />
            </div>
            <div class="flex min-h-0 items-center justify-center rounded-lg border border-solid border-n-weak bg-[#efe7dd] p-4 text-center text-sm text-[#667781]">
              Selecione um template para ver o preview.
            </div>
          </div>
        </section>
      </div>
    </div>
  </woot-modal>
</template>

<style scoped>
.modal-content {
  height: min(48rem, calc(100vh - 8rem));
  padding: 1rem 1.25rem 1.25rem;
}

:deep(.whatsapp-template-modal) {
  width: min(94vw, 76rem) !important;
}
</style>
